import React from 'react'
import { images } from 'Assets/Images'
import { usePrinterContext } from 'state/context/PrinterTemplatesContext'
import { FormatMoney } from 'Utils/functions'
import { disclaimers } from 'Views/PrinterPreview/constants'

export const DEFAULT_VALUE = disclaimers.regularCmf

export const Square5ToPrint = ({ products, i }) => {
  const { templateRef } = usePrinterContext()

  const prod = products?.content?.products?.[0]
  const terms = products?.content?.terms || DEFAULT_VALUE
  const prodBasePrice = FormatMoney(prod?.BasePrice || 0)

  return (
    <div style={{ width: '650px' }} ref={el => (templateRef.current[i] = el)}>
      <div
        id="printer-preview-left-canvas"
        data-testid="printer-preview-left-canvas"
        className="printer-preview-left-canvas">
        <div className="printer-preview-left-content-body">
          <p className="printer-preview-body-title-cmf">
            {prod?.ProductName || ''}
          </p>
          <p className="printer-preview-body-sku-cmf">{prod?.Sku || ''}</p>
          {prod?.BasePrice && (
            <div className="printer-preview-container-prices">
              <div className="printer-preview-content-price">
                <p
                  className="printer-preview-quote-1"
                  style={{
                    alignSelf: 'end',
                    marginBottom: 10,
                  }}>
                  36 cuotas desde
                </p>
                <div
                  className="printer-preview-container-price"
                  style={{
                    position: 'absolute',
                    bottom: 0,
                    left: 130,
                  }}>
                  <p className="printer-preview-price-simbol text-green-dark">
                    $
                  </p>
                  <p className="printer-preview-price text-green-dark">
                    {FormatMoney(prod?.cmfCredit || 0)?.split('.')?.[0] || ''}
                  </p>
                  <p className="printer-preview-price-mini text-green-dark">
                    .
                    {FormatMoney(prod?.cmfCredit || 0)?.split('.')?.[1] || '00'}
                  </p>
                </div>
              </div>
              <div className="printer-preview-content-price">
                <p className="printer-preview-quote-2">24 cuotas desde</p>
                <div className="printer-preview-container-price">
                  <p className="printer-preview-price-simbol-small text-green-dark">
                    $
                  </p>
                  <p className="printer-preview-price-small text-green-dark">
                    {FormatMoney(prod?.cmfCredit24 || 0)?.split('.')?.[0] || ''}
                  </p>
                  <p className="printer-preview-price-small-mini text-green-dark">
                    .
                    {FormatMoney(prod?.cmfCredit24 || 0)?.split('.')?.[1] ||
                      '00'}
                  </p>
                </div>
              </div>
              <div className="printer-preview-content-price">
                <p className="printer-preview-quote-2">12 cuotas desde</p>
                <div className="printer-preview-container-price">
                  <p className="printer-preview-price-simbol-small text-green-dark">
                    $
                  </p>
                  <p className="printer-preview-price-small text-green-dark">
                    {FormatMoney(prod?.cmfCredit12 || 0)?.split('.')?.[0] || ''}
                  </p>
                  <p className="printer-preview-price-small-mini text-green-dark">
                    .
                    {FormatMoney(prod?.cmfCredit12 || 0)?.split('.')?.[1] ||
                      '00'}
                  </p>
                </div>
              </div>
            </div>
          )}
        </div>
        <div className="printer-preview-left-content-footer">
          {prod?.BasePrice && (
            <div className="printer-preview-footer-container-price printer-preview-footer-prices-dividers">
              <p className="printer-preview-footer-price">Precio regular</p>
              <p className="printer-preview-price-small">
                {'$' + prodBasePrice}
              </p>
            </div>
          )}

          <div className="printer-preview-content-footer-input-wrapper template-terms-wrapper-to-remove">
            <p
              className="printer-preview-left-content-footer-legal-1"
              style={{
                border: 'none',
                height: '30px',
                background: 'transparent',
              }}>
              {terms}
            </p>
          </div>
        </div>
        <img
          className="printer-preview-left-image"
          src={images.printer.templates.cmf4}
          alt="template-preview"
          style={{ opacity: 0 }}
        />
      </div>
    </div>
  )
}
